<template>
  <a class="link u-inline-block u-relative" :href="href" target="_blank">
    <slot></slot>
  </a>
</template>


<script>
export default {
  props: {
    href: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClick () {
      if (this.disabled) return

      this.$emit('click')

      if (Object.keys(this.to).length) {
        this.$router.push(this.to)
      }
    }
  }
}
</script>


<style scoped lang="stylus">
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

.link
  &:before, &:after
    content ''
    position absolute
    top 100%
    width calc( 50% + 1px )
    height 2px
    opacity 1
    transform scale(1, 1)
    background-color $colors.white
    transition: transform .3s ease-in-out-sine, opacity .2s .1s linear
  
  &:before
    left 0
    transform-origin 0 50%
  
  &:after
    right 0    
    transform-origin 100% 50%

  &:hover
    &:before, &:after
      transform scale(0, 1)
      opacity 0

</style>
